import { LocationOn } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import React from 'react';

const LocationTribe = ({ tribeLocation = {} }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      minHeight={{ xs: '16px', md: '24px' }}
    >
      <LocationOn
        sx={{ fontSize: { xs: '16px', md: '20px' }, color: 'error300.main' }}
      />

      <Typography typography={{ xs: 'captionreguler', md: 'paragraph2' }}>
        {tribeLocation?.name}
      </Typography>
    </Stack>
  );
};

export default LocationTribe;
